// @file Composable for Google Drive
/// <reference types="@types/google.picker" />

import { captureException } from '@@/bits/error_tracker'
import { User as UserApi } from '@@/dashboard/padlet_api'
import { useGlobalSnackbarStore } from '@@/pinia/global_snackbar'
import { useSettingsIntegrationPermissionsStore } from '@@/pinia/settings_integration_permissions'

export const useGoogleDrive = (): {
  requestGoogleDriveAuthorization: typeof requestGoogleDriveAuthorization
  removeGoogleDriveAuthorization: typeof removeGoogleDriveAuthorization
} => {
  const requestGoogleDriveAuthorization = async ({
    userId,
    tenantId,
  }: {
    userId: number
    tenantId: number
  }): Promise<{ email: string; token: string }> => {
    return await new Promise((resolve, reject) => {
      const googleOauthTokenResponseHandler = (result): void => {
        window.removeEventListener('google_drive_auth', googleOauthTokenResponseHandler)
        return resolve({ email: result.detail.email, token: result.detail.accessToken })
      }
      window.addEventListener('google_drive_auth', googleOauthTokenResponseHandler)
      const oauthPath = `/auth/google_oauth2?tenant_id=${tenantId}&scope_alias=drive&afterwards=dispatch_parent_drive`
      const oauthWindow = window.open(oauthPath, 'google_oauth', 'height=600,width=450')
      if (oauthWindow != null) {
        oauthWindow.focus()
      }
    })
  }

  const removeGoogleDriveAuthorization = async (userId: number): Promise<void> => {
    // await an endpoint that will remove the google drive authorization
    try {
      await UserApi.removeGoogleDriveAuthorization(userId)
      useSettingsIntegrationPermissionsStore().clearGoogleDriveEmail()
    } catch (error) {
      void useGlobalSnackbarStore().genericFetchError()
      captureException(error)
    }
  }

  return {
    requestGoogleDriveAuthorization,
    removeGoogleDriveAuthorization,
  }
}
